// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"93b229aa","707":"3424a9dc","729":"bba36e1d"}[chunkId] + ".js";
};